module.exports = __webpack_public_path__ + "static/media/felicesFiestas.3e778a9a.png";